import helper from 'breakpoint-helper'

import config from '../../tailwind.config.js'

const breakpointHelper = helper(config.theme.screens)

export const { getBreakpoints, getMediaQuery, isMatching, listen, listenAll } =
  breakpointHelper

export default breakpointHelper
